(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brazil-buyer-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  var gsapScriptId = "brazil-hub-gsap-core";
  var gsapSource = "https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js";

  function loadGsap(callback) {
    if (window.gsap) {
      callback();
      return;
    }

    var existing = document.getElementById(gsapScriptId);
    if (existing) {
      existing.addEventListener("load", callback, { once: true });
      return;
    }

    var script = document.createElement("script");
    script.id = gsapScriptId;
    script.src = gsapSource;
    script.async = true;
    script.addEventListener("load", callback, { once: true });
    document.head.appendChild(script);
  }

  function initializeGlobe(root) {
    if (!root || !window.gsap) return;

    if (root.__brazilGlobeCleanup) {
      root.__brazilGlobeCleanup();
    }

    var strip = root.querySelector(".brazil-hub__world-strip");
    var stage = root.querySelector(".brazil-hub__globe-stage");
    var markers = root.querySelectorAll(".brazil-hub__brazil-marker");
    var halos = root.querySelectorAll(".brazil-hub__brazil-marker-halo");
    if (!strip || !stage) return;

    var tweens = [];
    var media = window.gsap.matchMedia();

    media.add(
      {
        desktop: "(min-width: 990px)",
        compact: "(max-width: 989px)",
        reduceMotion: "(prefers-reduced-motion: reduce)"
      },
      function (context) {
        var conditions = context.conditions;
        window.gsap.set(strip, { x: 165 });

        if (conditions.reduceMotion) {
          window.gsap.set(stage, { opacity: 0.26 });
          return;
        }

        tweens.push(
          window.gsap.fromTo(
            strip,
            { x: 165 },
            {
              x: -615,
              duration: conditions.compact ? 68 : 52,
              ease: "none",
              repeat: -1
            }
          )
        );

        tweens.push(
          window.gsap.to(markers, {
            y: -3,
            duration: 1.9,
            ease: "sine.inOut",
            repeat: -1,
            yoyo: true
          })
        );

        tweens.push(
          window.gsap.fromTo(
            halos,
            { scale: 0.55, opacity: 0.55 },
            {
              scale: 1.85,
              opacity: 0,
              duration: 2.8,
              ease: "power2.out",
              repeat: -1,
              stagger: 0.12,
              transformOrigin: "50% 50%"
            }
          )
        );
      }
    );

    var observer = null;
    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        function (entries) {
          var visible = entries[0] && entries[0].isIntersecting;
          tweens.forEach(function (tween) {
            if (visible && !document.hidden) {
              tween.resume();
            } else {
              tween.pause();
            }
          });
        },
        { rootMargin: "180px 0px", threshold: 0.01 }
      );
      observer.observe(stage);
    }

    function handleVisibility() {
      tweens.forEach(function (tween) {
        if (document.hidden) {
          tween.pause();
        } else if (!observer || stage.getBoundingClientRect().bottom > 0) {
          tween.resume();
        }
      });
    }

    document.addEventListener("visibilitychange", handleVisibility);

    root.__brazilGlobeCleanup = function () {
      document.removeEventListener("visibilitychange", handleVisibility);
      if (observer) observer.disconnect();
      media.revert();
      tweens.forEach(function (tween) {
        tween.kill();
      });
      tweens = [];
    };
  }

  function initializeAllGlobes() {
    document.querySelectorAll(".brazil-hub").forEach(initializeGlobe);
  }

  loadGsap(initializeAllGlobes);

  document.addEventListener("shopify:section:load", function (event) {
    loadGsap(function () {
      initializeGlobe(event.target.querySelector(".brazil-hub") || event.target);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jueqi-lead-hub"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-jueqi-floating]').forEach((floatingBar) => {
    const toggle = floatingBar.querySelector('.jueqi-floating__toggle');
    if (!toggle) return;

    const setOpen = (open) => {
      floatingBar.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const open = !floatingBar.classList.contains('is-open');
      setOpen(open);
      if (!open) toggle.blur();
    });

    floatingBar.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
        toggle.focus();
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (!floatingBar.contains(event.target)) setOpen(false);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
